import axios from 'axios';

const API = axios.create({ baseURL: '/api', timeout: 10000 });

// Derive absolute base URL for media/uploads
export const getBaseUrl = () => {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname, port } = window.location;
  // If we're on localhost:3000, backend is likely on :5000 (default dev)
  // If we're in production, backend is on the same origin
  if (hostname === 'localhost' && port === '3000') return 'http://localhost:5000';
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
};

export const getUploadUrl = (relativeUrl) => {
  if (!relativeUrl) return '';
  if (relativeUrl.startsWith('http')) return relativeUrl;
  return `${getBaseUrl()}${relativeUrl}`;
};

// ── Magazines ──
export const getMagazines    = (params = {}) => API.get('/magazines', { params });
export const getMagazineBySlug = slug        => API.get(`/magazines/${slug}`);
export const createMagazine  = data          => API.post('/magazines', data);
export const updateMagazine  = (id, data)    => API.put(`/magazines/${id}`, data);
export const deleteMagazine  = id            => API.delete(`/magazines/${id}`);

// ── Articles ──
export const getArticles     = (params = {}) => API.get('/articles', { params });
export const getMostRead     = ()             => API.get('/articles/most-read');
export const getArticleBySlug = slug          => API.get(`/articles/${slug}`);
export const createArticle   = data           => API.post('/articles', data);
export const updateArticle   = (id, data)     => API.put(`/articles/${id}`, data);
export const deleteArticle   = id             => API.delete(`/articles/${id}`);

// ── News (AI) ──
export const generateNews    = (topic, count = 6) => API.post('/news/generate', { topic, count });

// ── Subscribers ──
export const subscribe       = (name, email)  => API.post('/subscribers/subscribe',   { name, email });
export const unsubscribe     = email          => API.post('/subscribers/unsubscribe',  { email });

// ── Trends ──
export const getTrends       = ()             => API.get('/trends');
export const createTrend     = data           => API.post('/trends', data);

export default API;
